var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns gutter"},[_c('div',{staticClass:"column is-9"},[_c('h1',{staticClass:"title is-1 text color-white"},[_vm._v(" FAQ ")]),_c('div',{staticClass:"margin-bottom-xl"}),_c('div',{staticClass:"box is-large text"},[_c('faq-list')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }